export default {
  title: "Highlighted products",
  label: "No highlighted products selected",
  message: `Highlighted products are displayed in a cluster at the bottom of the page and
  should be used for products, which the user sees after scrolling throught the whole page
  and therefor should pursue him to view and buy them.`,
  select_product: "Select highlighted products",
  demo_message: "Here we will show your 'Highlighted products'."
}
